import {
  HABITS_LOAD_REQUEST,
  HABITS_LOAD_SUCCESS,
  HABITS_LOAD_FAIL,
  HABIT_CREATE_SUCCESS,
  HABIT_UPDATE_SUCCESS,
  HABIT_DELETE_SUCCESS,
  HABIT_STATS_SUCCESS,
  HABIT_DAILY_REPORTS_SUCCESS,
} from "./habitActions";

export const HabitReducer = (
  state = { data: [], stats: null, loading: false, error: null, dailyReports: [] },
  action,
) => {
  switch (action.type) {
    case HABITS_LOAD_REQUEST:
      return { ...state, loading: true, error: null };
    case HABITS_LOAD_SUCCESS:
      return { ...state, loading: false, data: action.payload || [] };
    case HABITS_LOAD_FAIL:
      return { ...state, loading: false, error: action.payload };
    case HABIT_CREATE_SUCCESS:
      return { ...state, data: [action.payload, ...state.data] };
    case HABIT_UPDATE_SUCCESS:
      return {
        ...state,
        data: state.data.map((habit) =>
          habit._id === action.payload._id ? action.payload : habit,
        ),
      };
    case HABIT_DELETE_SUCCESS:
      return {
        ...state,
        data: state.data.filter((habit) => habit._id !== action.payload),
      };
    case HABIT_STATS_SUCCESS:
      return { ...state, stats: action.payload };
    case HABIT_DAILY_REPORTS_SUCCESS:
      return { ...state, dailyReports: action.payload?.reports || [] };
    default:
      return state;
  }
};
